<template>
  <div class="container">
    <div class="introduce">
       <div class="information">
       <p>姓名：{{personArr.userName}}</p>
        <p v-if="personArr.employeeNo">工号：{{personArr.employeeNo}}</p>
        <p v-else>手机号：{{personArr.mobilePhone}}</p>
        <p>机构：{{personArr.departName}}</p>
      </div>
    </div>
     
    <van-tabs v-model="active" title-active-color="#DB0003" color="#DB0003" @click="onClick"> 
      <van-tab title="已完成" class="tabs">
         <div>
          <p>累计人数:<span class="text">{{totalRecordCountAll}}</span>人  保费金额:<span  class="text">{{sumAmountAll}}</span>元</p>
          <div class="order" v-for="(item,index) in orderListAll" :key="index">
            <h3>巴陵e惠保</h3>
            <p>
              <span>投保人:</span>
              <span>{{item.appntName}}</span>
            </p>
            <p>
              <span>被保人:</span>
              <span>{{item.insuredPersonName}}</span>
            </p>
            <p>
              <span>投保人手机号:</span>
              <span>{{item.appntMobileNumber}}</span>
            </p>
            <p>
              <span>订单创建时间：</span>
              <span>{{item.polApplyDate}}</span>
            </p>
            <p>
              <span>保费：</span>
              <span>{{item.insuredFeeAmount}}</span>
            </p>
            <p>
              <span>保单状态：</span>
              <span>{{item.insuranceStatus | insuranceStatusFilter}}</span>
            </p>
            <p v-if="item.payType">
              <span>支付方式：</span>
              <span>{{item.payType | payFilter}}</span>
            </p>
          </div>
         
        </div>
        
      </van-tab>
      <van-tab title="待处理" class="tabs">
         <div>
          <p v-show="false">累计人数:<span class="text">{{totalRecordCountAll}}</span>人  保费金额:<span  class="text">{{sumAmountAll}}</span>元</p>
          <div class="order" v-for="(item,index) in orderListAll" :key="index">
            <h3>巴陵e惠保</h3>
            <p>
              <span>投保人:</span>
              <span>{{item.appntName}}</span>
            </p>
            <p>
              <span>被保人:</span>
              <span>{{item.insuredPersonName}}</span>
            </p>
            <p>
              <span>投保人手机号:</span>
              <span>{{item.appntMobileNumber}}</span>
            </p>
            <p>
              <span>订单创建时间：</span>
              <span>{{item.polApplyDate}}</span>
            </p>
            <p>
              <span>保费：</span>
              <span>{{item.insuredFeeAmount}}</span>
            </p>
            <p>
              <span>保单状态：</span>
              <span>{{item.insuranceStatus | insuranceStatusFilter}}</span>
            </p>
            <p v-if="item.payType">
              <span>支付方式：</span>
              <span>{{item.payType|payFilter}}</span>
            </p>
          </div>
         
        </div>
      </van-tab>
      <van-tab title="全部" class="tabs">
        <div>
          <p v-show="false">累计人数:<span class="text">{{totalRecordCountAll}}</span>人  保费金额:<span  class="text">{{sumAmountAll}}</span>元</p>
          <div class="order" v-for="(item,index) in orderListAll" :key="index">
            <h3>巴陵e惠保</h3>
            <p>
              <span>投保人:</span>
              <span>{{item.appntName}}</span>
            </p>
            <p>
              <span>被保人:</span>
              <span>{{item.insuredPersonName}}</span>
            </p>
            <p>
              <span>投保人手机号:</span>
              <span>{{item.appntMobileNumber}}</span>
            </p>
            <p>
              <span>订单创建时间：</span>
              <span>{{item.polApplyDate}}</span>
            </p>
            <p>
              <span>保费：</span>
              <span>{{item.insuredFeeAmount}}</span>
            </p>
            <p>
              <span>保单状态：</span>
              <span>{{item.insuranceStatus | insuranceStatusFilter}}</span>
            </p>
            <p v-if="item.payType">
              <span>支付方式：</span>
              <span>{{item.payType | payFilter}}</span>
            </p>
          </div>
         
        </div>
      </van-tab>
      <div class="title_but">由北京圆心惠保科技有限公司提供技术支持</div>
    </van-tabs>
    <div class="poster_a">
      <div  @click="posterdetail">海报生成</div>
      <div  @click="inquiry">业绩查询</div>
    </div>
  </div>
</template>
<script>
import { findAgentUserById, findUserInsurancePage} from '@/api/poster'
import { PayAccountTypeStatus, PolicyStatus } from '@/util/enum-data'
export default {
  filters:{
    payFilter(val) {
      return PayAccountTypeStatus[val] ?  PayAccountTypeStatus[val]: '其他'
    },
    insuranceStatusFilter(val){
      return PolicyStatus[val] ?  PolicyStatus[val]: ''
    }
  },
  data() {
    return {
      active: 0,
      storageArr:[],
      personArr:[],
      orderListAll:[],
      sumAmountAll:'',
      totalRecordCountAll:''
    };
  },
  mounted(){
    this.storageArr=JSON.parse(localStorage.getItem("orderSn"))
    console.log(this.storageArr)
     this.getUserList()
     this.getcompletedList()
    // this.getpendingList()
  },
  methods:{
     // 获取个人信息
    getUserList(){
      findAgentUserById({
             id:this.storageArr.id,
             token:this.storageArr.token
           }).then(res=>{
        console.log(res,'个人信息')
        this.personArr=res
      })
    },
      posterdetail(){
        this.$router.push({
          path: '/poster-deal',query:{
             id:this.storageArr.id,
             token:this.storageArr.token
           }
        })
    },
     inquiry(){
        this.$router.push({
          path: '/performance-inquiry',query:{
             id:this.storageArr.id,
             token:this.storageArr.token
           }
        })
    },
    getorderList(){
      this.orderListAll= []
      this.totalRecordCountAll = ''
      let params={
        pageNum:1,
        pageSize:100,
        id:this.storageArr.id,
        token:this.storageArr.token,
      }
    
      findUserInsurancePage(params).then(res=>{
        this.orderListAll=res.dataList
        this.sumAmountAll=res.sumAmount
        this.totalRecordCountAll=res.totalRecordCount
      }).catch((err)=>{
        console.log(err)
      })
    },
     getpendingList(){
       this.orderListAll= []
       this.totalRecordCountAll = ''
      let params={
        pageNum:1,
        pageSize:100,
         id:this.storageArr.id,
        token:this.storageArr.token,
        type:'pending'
      }
     
      findUserInsurancePage(params).then(res=>{
        console.log(res,'222')
        this.orderListAll=res.dataList
        this.sumAmountAll=res.sumAmount
        this.totalRecordCountAll=res.totalRecordCount
      })
    },
     getcompletedList(){
      this.orderListAll= []
      this.totalRecordCountAll = ''
      let params={
        pageNum:1,
        pageSize:100,
         id:this.storageArr.id,
        token:this.storageArr.token,
        type:'completed'
      }
      findUserInsurancePage(params).then(res=>{
        console.log(res)
        this.orderListAll=res.dataList
        this.sumAmountAll=res.sumAmount
        this.totalRecordCountAll=res.totalRecordCount
      })
    },
     onClick(name, title) {
      console.log(name,title);
      if(name==0){
        this.getcompletedList()
      }else if(name==1){
        this.getpendingList()
      }else if(name==2){
        this.getorderList()
      }
    },
  }
};
</script>


<style  lang="scss" scoped >
/* *{
    margin: 0;
    padding: 0;
} */
.container{
    min-height: 100vh;
    padding-bottom: 60px;
    background: #F2F2F2;
}
.introduce{
    // background: #F2F2F2;
    padding: 10px 20px;
}
.information{
  background: #fff;
    padding: 10px;
    border-radius: 10px;
}

.tabs{
      background: #F2F2F2;
    padding: 30px 20px;
    
    .text{
      color: #DB0003;
      font-weight: bold;
    }
}
.order{
  background: #fff;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 10px;
    p{
          display: flex;
    justify-content: space-between;
    }
}
.poster_a{
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 0;
  font-size: px2rem(32);
  font-weight: 400;
  color: #4C4C4C;
  height: px2rem(100);
  line-height: px2rem(100);
  text-align: center;
  background: #fff;
  div{
    flex: 1;
    cursor: pointer;
  }
  div:nth-child(2){
    font-weight: bold;
    color: #DB0003;
    background: #F2F2F2;
  }
}
.title_but{
  text-align: center;
  font-size: 12px;
}
</style>